@for(star of stars; track star) {
<mat-icon class="star">{{star}}</mat-icon>
}